<app-loading text="Carregando..." *ngIf="loading"></app-loading>

<div class="container" *ngIf="!loading">
  <app-header></app-header>

  <div class="body">
    <div class="title">
      <div class="thumb" [style.background-image]="'url(' + thumbImage + ')'"></div>
      <div class="info">
        <div class="merchant-name">
          {{ installation.name }}
        </div>
        <div class="merchant-info">
          <div class="time opened" *ngIf="installation.isOpened">Aberto</div>
          <div class="time closed" *ngIf="!installation.isOpened">Fechado</div>
          <div class="separator"></div>
          <div class="body-small text-color-subtitle">{{ tableName }}</div>
          <div class="separator" *ngIf="installation.instagram && !configTablet"></div>
          <a *ngIf="installation.instagram && !configTablet" class="instagram" (click)="handleClickInstagram()">
            <yoo-icon icon="instagram" size="small"></yoo-icon>
            Instagram
            <yoo-icon icon="caret-right" size="small"></yoo-icon>
          </a>
        </div>
      </div>
    </div>
    <div class="w-100 d-column gap-2 m-2">
      <mnt-button
        label="Ver cardápio"
        icon-left="restaurant"
        full-width
        [variant]="!enablePaymentButton || !modulePaymentTable? 'emphasis' : 'regular'"
        [color]="!enablePaymentButton || !modulePaymentTable ? 'primary' : 'neutral'"
        size="large"
        [disabled]="openingOnlineMenu"
        (buttonClick)="navigateToCart()"
      ></mnt-button>
      <mnt-button
        label="Ver conta"
        icon-left="receipt"
        full-width
        variant="regular"
        color="neutral"
        size="large"
        [disabled]="!enableSummaryButton || !installation.isOpened"
        (buttonClick)="goToOrderSummary()"
      ></mnt-button>
      <mnt-button
        label="Pagar conta"
        icon-left="currencySimple"
        full-width
        [variant]="enablePaymentButton && modulePaymentTable ? 'emphasis' : 'regular'"
        [color]="enablePaymentButton && modulePaymentTable ? 'primary' : 'neutral'"
        size="large"
        [disabled]="!enablePaymentButton || !installation.isOpened || !modulePaymentTable"
        (buttonClick)="handlePayBill()"
      ></mnt-button>
      <mnt-button
        *ngIf="displayReceiptsButton"
        label="Ver comprovantes"
        icon-left="receipt"
        full-width
        variant="plain"
        color="neutral"
        size="large"
        [disabled]="!displayReceiptsButton || !modulePaymentTable"
        (buttonClick)="showReceipts()"
      ></mnt-button>
    </div>
  </div>
  <div class="footer">
    <a target="_blank" href="https://yooga.com.br/">
      <small>Feito com tecnologia</small>
      <img src="assets/yooga.svg" alt="">
    </a>
    <small>v{{ version }}</small>
  </div>
</div>
